import { useRouteShare } from 'routes';

import { IconButton } from 'components/Blocks';
import { LinkIcon } from 'components/Icons';

import { projectTabs } from 'pages/Projects/ProjectProfile/tabs';

import { BaseProps } from './types';

export function IssueLink({ issue }: Pick<BaseProps, 'issue'>) {
  const copyIssueLink = useRouteShare('projectProfile');

  return (
    <IconButton
      tooltipContent="Copy Issue link"
      size="small"
      onClick={() =>
        copyIssueLink({
          projectId: issue.project,
          issueId: issue.id,
          tab: projectTabs.issues,
        })
      }
    >
      <LinkIcon size={14} />
    </IconButton>
  );
}
